import React from 'react';

import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Actions from './Actions';
import getLocalFormattedTime from './utils';

const Row = ({ order, index, fetchOrders }) => {
  const { orderId, ccBusinessLegalName, createdAt, updatedAt, status } = order;

  return (
    <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{orderId}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {ccBusinessLegalName}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{status}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getLocalFormattedTime(createdAt)}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getLocalFormattedTime(updatedAt)}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Actions status={status} order={order} fetchOrders={fetchOrders} />
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
